import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../utils/redux/userSlice";
import { Machine } from "../utils/models/Machine";
import { ISelectOptions } from "aw-combobox";
import { getAllMachines } from "../utils/services/machine.service";
import Select from 'react-select'
import { Form, Spinner, Table } from "react-bootstrap";
import Sync from './../utils/resources/ModuleIcons/Check.png'
import NoSync from './../utils/resources/ModuleIcons/NoCheck.png'
import Arrow from './../utils/resources/ModuleIcons/arrow.png'
import { getRandomNumber } from "aw-generic-functions";

const DigitalTwinModulePage = () => {
    const { t } = useTranslation();
    const user = useSelector(selectUser)
    const context: IOutletContext = useOutletContext()
    const [machines, setMachines] = useState<Machine[]>([])
    const [machinesObj, setMachinesObj] = useState<ISelectOptions[]>([])
    const [selectedMachine, setSelectedMachine] = useState<ISelectOptions>()
    const [loading, setLoading] = useState(false)

    const defCloudParams = [
        { id: 1, param: t('Temperature'), value: getRandomNumber(25, 50), sync: true },
        { id: 2, param: t('Humidity'), value: 52, sync: true },
        { id: 3, param: t('Presure'), value: getRandomNumber(25, 50), sync: true },
        { id: 4, param: t('Speed'), value: 66, sync: true },
        { id: 5, param: t('Time'), value: 10, sync: true },
        { id: 6, param: t('Vibration'), value: getRandomNumber(25, 50), sync: true }
    ]

    const defMachineParams = [
        { id: 1, param: t('Temperature'), value: getRandomNumber(25, 50), sync: false },
        { id: 2, param: t('Humidity'), value: 52, sync: true },
        { id: 3, param: t('Presure'), value: getRandomNumber(25, 50), sync: false },
        { id: 4, param: t('Speed'), value: 66, sync: true },
        { id: 5, param: t('Time'), value: 10, sync: true },
        { id: 6, param: t('Vibration'), value: getRandomNumber(25, 50), sync: false }
    ]


    const [cloudParams, setCloudParams] = useState(defCloudParams)
    const [machineParams, setMachineParams] = useState(defMachineParams)

    useEffect(() => {
        context.setState(t('DigitalTwin'));
    }, [context, t]);

    useEffect(() => {
        getAllMachines(user.token)
            .then((machines: Machine[]) => setMachines(machines))
            .catch((e) => console.log('Error get machines', e))
    }, [])

    useEffect(() => {
        if (machines.length > 0) {
            const mObj: ISelectOptions[] = []
            machines.forEach((m) => {
                mObj.push({ value: m.idmachine, label: m.name })
            })
            mObj.sort((a, b) => Number(a.value) - Number(b.value))
            setMachinesObj(mObj)
            setSelectedMachine(mObj[0])
        } else
            setMachinesObj([])
    }, [machines])

    useEffect(() => {
        setCloudParams(defCloudParams)
        setMachineParams(defMachineParams)
    }, [selectedMachine])

    const onChangeParam = (value: string, id: number, cloud: boolean) => {
        setCloudParams((prevValue) => {
            return prevValue.map((v) => {
                if (v.id === id) {
                    let valueAux = 0
                    try {
                        valueAux = parseInt(value)
                    } catch (e) {
                        valueAux = 0
                    }
                    return cloud ? { ...v, value: valueAux } : { ...v, sync: false }
                }
                else
                    return v
            })
        })

        setMachineParams((prevValue) => {
            return prevValue.map((v) => {
                if (v.id === id) {
                    let valueAux = 0
                    try {
                        valueAux = parseInt(value)
                    } catch (e) {
                        valueAux = 0
                    }
                    return !cloud ? { ...v, value: valueAux } : { ...v, sync: false }
                }
                else
                    return v
            })
        })
    }

    const syncData = (cloudToMachine: boolean) => {
        if (cloudToMachine) {
            const cloudAux = cloudParams.map((p) => ({ ...p, sync: true }))
            setCloudParams(cloudAux)
            setMachineParams([...cloudAux])
        } else {
            const machineAux = machineParams.map((p) => ({ ...p, sync: true }))
            setCloudParams([...machineAux])
            setMachineParams(machineAux)
        }
        setLoading(false)
    }

    const syncDataTimeOut = (cloudToMachine: boolean) => {
        setLoading(true)
        setTimeout(() => syncData(cloudToMachine), 5000)
    }



    return (
        <>
            <div className='row border-0 mx-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-sm-8 col-md px-2 mt-2'>
                    <div className='rounded-1 p-3 d-flex flex-column' style={{ backgroundColor: 'var(--IDBlackLight)' }}>
                        <section style={{ width: '15rem' }}>
                            <Select className="w-100" isDisabled={false} closeMenuOnSelect={true} value={selectedMachine} onChange={(e: any) => setSelectedMachine(e)} options={machinesObj} />
                        </section>
                    </div>
                </div>
            </div >
            <div className='d-none d-lg-flex border-0 mt-2 mx-2 px-2 justify-content-between' style={{ maxWidth: '100%' }}>
                <section className="rounded-1 text-center pt-1 px-2" style={{ backgroundColor: 'var(--IDBlackLight)', height: '500px', flex: '1 1 0', marginRight: '8px', color: 'white' }}>
                    <span className="h4">{t('Machine')}</span>
                    <Table hover className='gridsStyle text-start'>
                        <thead>
                            <tr>
                                <th>{t('Param')}</th>
                                <th>{t('Value')}</th>
                                <th className="text-end">{t('Sync')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {machineParams.map((v, i) => {
                                return (<tr key={i} className={`tableLine`}>
                                    <td>{v.param}</td>
                                    <td className="w-25"><Form.Control disabled={loading} type="number" value={v.value} onChange={(e) => onChangeParam(e.target.value, v.id, false)} /></td>
                                    <td className="text-end"><img src={v.sync ? Sync : NoSync} height={25} /></td>
                                </tr>)
                            })}
                        </tbody>
                    </Table>
                </section>
                <section className="rounded-1 d-flex flex-column justify-content-center align-items-center" style={{ backgroundColor: 'var(--IDBlackLight)', height: '500px', width: '50px', flex: '0 0 50px', marginRight: '8px' }}>
                    <section>
                        {!loading && <div onClick={() => syncDataTimeOut(false)} style={{ cursor: "pointer", marginBottom: '1rem', backgroundColor: 'var(--IDBlack)', borderRadius: '0.25rem', padding: '0.25rem' }}><img src={Arrow} height={30} /></div>}
                        {!loading && <div onClick={() => syncDataTimeOut(true)} style={{ cursor: "pointer", marginBottom: '1rem', backgroundColor: 'var(--IDBlack)', borderRadius: '0.25rem', padding: '0.25rem' }}><img src={Arrow} height={30} style={{ transform: 'rotate(180deg)' }} /></div>}
                        {loading && <Spinner animation="grow" style={{ color: '#3f87d6' }} />}
                    </section>
                </section>
                <section className="rounded-1 text-center pt-1 px-2" style={{ backgroundColor: 'var(--IDBlackLight)', height: '500px', flex: '1 1 0', color: 'white' }} >
                    <span className="h4">{t('Cloud')}</span>
                    <Table hover className='gridsStyle text-start'>
                        <thead>
                            <tr>
                                <th>{t('Param')}</th>
                                <th>{t('Value')}</th>
                                <th className="text-end">{t('Sync')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cloudParams.map((v, i) => {
                                return (<tr key={i} className={`tableLine`}>
                                    <td>{v.param}</td>
                                    <td className="w-25"><Form.Control disabled={loading} type="number" value={v.value} onChange={(e) => onChangeParam(e.target.value, v.id, false)} /></td>
                                    <td className="text-end"><img src={v.sync ? Sync : NoSync} height={25} /></td>
                                </tr>)
                            })}
                        </tbody>
                    </Table>
                </section>
            </div>



            <div className='d-flex d-lg-none border-0 mt-2 mx-2 px-2 flex-column justify-content-between' style={{ maxWidth: '100%' }}>
                <section className="rounded-1 text-center pt-1 px-2" style={{ backgroundColor: 'var(--IDBlackLight)', height: '400px', flex: '1 1 0', color: 'white' }}>
                    <span className="h4">{t('Cloud')}</span>
                    <Table hover className='gridsStyle text-start'>
                        <thead>
                            <tr>
                                <th>{t('Param')}</th>
                                <th>{t('Value')}</th>
                                <th>{t('Sync')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cloudParams.map((v, i) => {
                                return (<tr key={i} className={`tableLine`}>
                                    <td>{v.param}</td>
                                    <td className="w-25"><Form.Control disabled={loading} type="number" value={v.value} onChange={(e) => onChangeParam(e.target.value, v.id, true)} /></td>
                                    <td><img src={v.sync ? Sync : NoSync} height={25} /></td>
                                </tr>)
                            })}
                        </tbody>
                    </Table>
                </section>
                <section className="rounded-1 d-flex justify-content-center align-items-center my-1" style={{ backgroundColor: 'var(--IDBlackLight)', height: '50px', flex: '0 0 50px' }}>
                    <section className="d-flex flex-row">
                        {!loading && <div onClick={() => syncDataTimeOut(true)} style={{ cursor: "pointer", marginRight: '1rem', backgroundColor: 'var(--IDBlack)', borderRadius: '0.25rem', padding: '0.25rem' }}><img src={Arrow} height={30} style={{ transform: 'rotate(90deg)' }} /></div>}
                        {!loading && <div onClick={() => syncDataTimeOut(false)} style={{ cursor: "pointer", backgroundColor: 'var(--IDBlack)', borderRadius: '0.25rem', padding: '0.25rem' }}><img src={Arrow} height={30} style={{ transform: 'rotate(270deg)' }} /></div>}
                        {loading && <Spinner animation="grow" style={{ color: '#3f87d6' }} />}
                    </section>
                </section>
                <section className="rounded-1 text-center pt-1" style={{ backgroundColor: 'var(--IDBlackLight)', height: '400px', flex: '1 1 0', color: 'white' }} >
                    <span className="h4">{t('Machine')}</span>
                    <Table hover className='gridsStyle text-start'>
                        <thead>
                            <tr>
                                <th>{t('Param')}</th>
                                <th>{t('Value')}</th>
                                <th>{t('Sync')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {machineParams.map((v, i) => {
                                return (<tr key={i} className={`tableLine`}>
                                    <td>{v.param}</td>
                                    <td className="w-25"><Form.Control disabled={loading} type="number" value={v.value} onChange={(e) => onChangeParam(e.target.value, v.id, false)} /></td>
                                    <td><img src={v.sync ? Sync : NoSync} height={25} /></td>
                                </tr>)
                            })}
                        </tbody>
                    </Table>
                </section>
            </div>

        </>
    )
}

export default DigitalTwinModulePage;
